module.exports = __webpack_public_path__ + "static/Cases4-1dc0fa5ce165c53a8f56602fad9f128c.svg";